import { useEffect } from 'react';

import isChanged from '../utils/is-changed';

export default ({ assignment, editAssignment, setDisabled }: any) => {
  useEffect(() => {
    setDisabled(!isChanged(editAssignment, assignment));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editAssignment]);
};
